export default async function asyncTimeout(callback: () => Promise<void> | void, delay?: number) {
  return new Promise<void>((resolve) =>
    setTimeout(async () => {
      await callback();
      resolve();
    }, delay)
  );
}
